<template>
  <div class="row mb-5">
    <div class="col-12 col-md-6">
      <div
        v-if="isLoading"
        class="d-flex justify-content-center p-5 mb-5 mb-md-0"
      >
        <i class="fas fa-spinner fa-2x fa-spin"></i>
      </div>
      <div
        class="d-flex flex-column px-5"
        v-if="!isLoading"
      >
        <div class="">
          <h3 class="font-weight-bold mb-3">{{ content.title }}</h3>
          <p class="h5 mb-5">{{ content.subtitle }}</p>
        </div>
        <div class="">
          <p class="text-primary font-weight-bold mb-1">Dettagli della tua ricerca</p>
          <ul
            v-if="ricercaToShow"
            class="text"
          >
            <li
              v-for="(elem, key) in ricercaToShow"
              :key="key"
              class="mb-1"
            >
              <b>{{ elem.title }}:</b> {{ elem.value }}
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="col-12 col-md-6">
      <div class="d-flex flex-column px-5 pl-md-0">
        <div class="form-group mb-0">
          <label class="text-primary mb-0" for="nome">Titolo ricerca *</label>
          <input
            id="nome"
            v-model="ricerca.name"
            class="form-control textfield"
            type="text"
            placeholder="Inserisci un titolo per la tua ricerca..."
            required
          >
        </div>

        <template v-if="!isLoggedIn">
          <div class="form-group mb-0">
            <label class="text-primary mb-0" for="nome">Nome *</label>
            <input
              id="nome"
              v-model="utente.nome"
              class="form-control textfield"
              type="text"
              placeholder="Inserisci il tuo nome..."
              required
            >
          </div>
          <div class="form-group mb-0">
            <label class="text-primary mb-0" for="cognome">Cognome *</label>
            <input
              id="cognome"
              v-model="utente.cognome"
              class="form-control textfield"
              type="text"
              placeholder="Inserisci il tuo cognome..."
              required
            >
          </div>
          <div class="form-group mb-0">
            <label class="text-primary mb-0" for="email">Indirizzo e-mail *</label>
            <input
              id="email"
              v-model="utente.email"
              class="form-control textfield"
              type="text"
              placeholder="Inserisci la tua e-mail..."
              required
            >
          </div>
          <div class="ez-checkbox pull-left">
            <label>
              <input
                class="ez-hide"
                type="checkbox"
                v-model="utente.privacy"
              >
              Acconsento al trattamento dei miei dati personali
            </label>
          </div>
        </template>

        <div class="d-flex justify-content-end mt-2">
          <button
            class="btn btn-primary d-flex"
            :disabled="$v.$invalid"
            data-gtm-event="click_salva_ricerca_riepilogo_v2"
            @click="onNextStep"
          >
            Avanti
            <i class="material-icons ml-1" data-gtm-event="click_salva_ricerca_riepilogo_v2">keyboard_arrow_right</i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, email, requiredIf } from 'vuelidate/lib/validators';
import * as helper from '../../classes/helper.class';

export default {
  name: 'SalvaRicercaRiepilogo',

  mixins: [validationMixin],

  props: ['ricerca', 'utente', 'content'],

  validations(context = null) {
        const validation = {
            ricerca: {
                name: { required },
            },
            utente: {
                nome: { required },
                cognome: { required },
                email: { required, email },
                privacy: {}
            }
        }

        if(! this.isLoggedIn){
            validation.utente.privacy = { required }; 
        }

        return validation;
  },

  data () {
    return {
      ricercaToShow: null,
      isLoading: false,
    }
  },

  computed: {
    isLoggedIn () {
      return this.$root.user.id !== null
    },
  },

  mounted () {
    // Faccio una richiesta al server passandogli la ricerca attuale
    this.isLoading = true
    window.axios.post(window.base_url + 'searches/my-search/riepilogo', this.ricerca.payload)
      .then((response) => {
        this.isLoading = false;
        this.ricercaToShow = response.data.data;
        this.ricerca.name = Object.values(this.ricercaToShow).map((x) => x.value).join(' - ');
      })
      .catch((error) => {
        this.isLoading = false;
        if (error.response.status === 422) {
          helper.parseError(error);
        } else {
          Swal.fire({
            title: 'Attenzione!',
            text: 'Si è verificato un errore inatteso, contattare l\'assistenza.',
            type: 'error'
          });
        }
      })
  },

  methods: {
    onNextStep () {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.$emit('next-step');
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.form-group {
  label {
    font-weight: 600;
  }

  input {
    border-radius: 0;
  }
}
</style>
